import { ErrorHandler, inject, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  loggerService = inject(LoggerService);

  handleError(error: any): void {
    this.loggerService.logException(error, 'Angular Global Error');

    console.log('GlobalErrorHandler', error);
    throw error;
  }
}
